export function validatePhoneNumber(phone) {
  if (!phone || phone.trim() === '') {
    return { isValid: false, error: 'Phone number is required' }
  }

  const cleaned = phone.replace(/\s+/g, '').replace(/[()-]/g, '')
  
  if (cleaned.length < 10) {
    return { isValid: false, error: 'Phone number must be at least 10 digits' }
  }

  if (cleaned.length > 15) {
    return { isValid: false, error: 'Phone number is too long (maximum 15 digits)' }
  }

  const phoneRegex = /^\+?[1-9]\d{9,14}$|^[1-9]\d{9,14}$/
  
  if (!phoneRegex.test(cleaned)) {
    return { isValid: false, error: 'Please enter a valid phone number' }
  }

  return { isValid: true, error: null }
}

export function formatPhoneNumber(phone) {
  if (!phone) return ''
  
  const cleaned = phone.replace(/\D/g, '')
  
  if (cleaned.length === 0) return ''
  
  if (cleaned.length <= 3) {
    return cleaned
  } else if (cleaned.length <= 6) {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3)}`
  } else {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6, 10)}`
  }
}
